import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const DarkTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: 'center',
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: '1rem',
    maxWidth: 200,
    borderRadius: 3,
    padding: '11px 16px 13px 16px'
  },
  arrow: {
    color: theme.palette.common.black
  }
}))(Tooltip);

export default DarkTooltip
